import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { WtfAnimations } from '../../../../utils/others/core/animations';

@Component({
    selector: 'wtf-profile-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    animations: WtfAnimations
})
export class ProfileAboutComponent implements OnInit {
    timeline: any;
    posts: any;


    ngOnInit() {

    }
}
